import apiClient from "@/api/axiosClient";

export interface AssetRequest {
  id: string;
  requestedByAzureObjectId: string;
  requestedByDisplayName?: string;
  categoryId?: string;
  categoryName?: string;
  justification: string;
  status: "Pending" | "Approved" | "Rejected" | "Fulfilled";
  reviewedByDisplayName?: string;
  reviewedAt?: string;
  reviewComments?: string;
  createdAt: string;
}

export interface MyAccess {
  azureObjectId?: string;
  roles: string[];
  isElevated: boolean;
  isEmailAuthTenant: boolean;
}

export async function fetchMyAccess(): Promise<MyAccess> {
  const { data } = await apiClient.get<MyAccess>("/users/me/access");
  return data;
}

export async function fetchAssetRequests(): Promise<AssetRequest[]> {
  const { data } = await apiClient.get<AssetRequest[]>("/asset-requests");
  return data;
}

export async function createAssetRequest(payload: { categoryId?: string; justification: string }): Promise<AssetRequest> {
  const { data } = await apiClient.post<AssetRequest>("/asset-requests", payload);
  return data;
}

export async function reviewAssetRequest(id: string, payload: { status: "Approved" | "Rejected"; reviewComments?: string }): Promise<AssetRequest> {
  const { data } = await apiClient.post<AssetRequest>(`/asset-requests/${id}/review`, payload);
  return data;
}
